var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Body, H1 } from "@irati/ui/src/Typography";
import Form from "@irati/ui/src/Form";
import { FormattedMessage } from "@irati/utils/lang";
import SagaStep from "../../../components/ProductForms/SagaStep";
import OpenValueInputContainer from "../../../components/ProductForms/OpenValue/OpenValueInputContainer";
var OpenValueProduct = /** @class */ (function (_super) {
    __extends(OpenValueProduct, _super);
    function OpenValueProduct() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenValueProduct.prototype.render = function () {
        var _a = this.props, deal = _a.deal, products = _a.products;
        return (React.createElement("div", null,
            React.createElement(SagaStep, null),
            React.createElement(H1, null,
                React.createElement(FormattedMessage, { id: "perks.productForms.openValueProduct.header" })),
            React.createElement(Body, { margin: [2, 0, 4], width: "80%" },
                React.createElement(FormattedMessage, { id: "perks.productForms.openValueProduct.desc" })),
            React.createElement(Form, null,
                React.createElement(OpenValueInputContainer, { deal: deal, products: products }))));
    };
    return OpenValueProduct;
}(PureComponent));
export default OpenValueProduct;
